webpackJsonp([4],{

/***/ "./pages/about.js":
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _typography = __webpack_require__("./utils/typography.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var About = function (_React$Component) {
	  _inherits(About, _React$Component);
	
	  function About() {
	    _classCallCheck(this, About);
	
	    return _possibleConstructorReturn(this, (About.__proto__ || Object.getPrototypeOf(About)).apply(this, arguments));
	  }
	
	  _createClass(About, [{
	    key: "render",
	    value: function render() {
	      return Glamor.createElement(
	        "div",
	        {
	          css: {
	            padding: (0, _typography.rhythm)(3 / 4)
	          }
	        },
	        Glamor.createElement(
	          "h1",
	          null,
	          "About Gatsbygram"
	        ),
	        Glamor.createElement(
	          "p",
	          null,
	          "Gatsbygram is an example website built with the JavaScript web framework",
	          " ",
	          Glamor.createElement(
	            "a",
	            { target: "_blank", href: "https://github.com/gatsbyjs/gatsby" },
	            "Gatsby"
	          ),
	          "."
	        ),
	        Glamor.createElement(
	          "p",
	          null,
	          "The code for the site lives at",
	          " ",
	          Glamor.createElement(
	            "a",
	            {
	              href: "https://github.com/gatsbyjs/gatsby/tree/1.0/examples/gatsbygram",
	              target: "_blank"
	            },
	            "https://github.com/gatsbyjs/gatsby/tree/1.0/examples/gatsbygram"
	          )
	        )
	      );
	    }
	  }]);
	
	  return About;
	}(_react2.default.Component);
	
	exports.default = About;
	module.exports = exports["default"];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/glamor/react.js")))

/***/ }

});


// WEBPACK FOOTER //
// page-component---pages-about-js-d2ba0e62d1866522528f.js